webpackJsonp([214009684400939],{

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/subbu.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/KarnikaVallabh.jpg";
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/wob/4dec2025/1.png";
	var I2 = "https://www.winpeforum.com/assets/wob/4dec2025/2.png";
	var I3 = "https://www.winpeforum.com/assets/wob/4dec2025/3.png";
	var I4 = "https://www.winpeforum.com/assets/wob/4dec2025/4.png";
	var I5 = "https://www.winpeforum.com/assets/wob/4dec2025/5.png";
	var I6 = "https://www.winpeforum.com/assets/wob/4dec2025/6.png";
	var I7 = "https://www.winpeforum.com/assets/wob/4dec2025/7.png";
	var I8 = "https://www.winpeforum.com/assets/wob/4dec2025/8.png";
	var I9 = "https://www.winpeforum.com/assets/wob/4dec2025/9.png";
	var I10 = "https://www.winpeforum.com/assets/wob/4dec2025/10.png";
	var I11 = "https://www.winpeforum.com/assets/wob/4dec2025/11.png";
	var I12 = "https://www.winpeforum.com/assets/wob/4dec2025/12.png";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/1.png";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/2.png";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/3.png";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/4.png";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/5.png";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/6.png";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/7.png";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/8.png";
	var II9 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/9.png";
	var II10 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/10.png";
	var II11 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/11.png";
	var II12 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/12.png";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: " ",
	      name: "Mr. Subbu Subramaniam",
	      post: "<div>Former CFO of Titan Company Ltd. &<br/> Independent Director on multiple boards\n\n\n\n          </div>"
	    }];
	
	    _this.Speaker2 = [{
	      imgUrl: icon2,
	      desc: "Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.\n<br/><br/>\nAt McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.\n\n\n         ",
	      name: "Alka Goel",
	      post: "<div>Founding Partner<br/> Alkemi Growth Capital\n        </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 35, ImgSrc: I2, ImgSrc1: II2 }, { id: 22, ImgSrc: I3, ImgSrc1: II3 }, { id: 19, ImgSrc: I4, ImgSrc1: II4 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 34, ImgSrc: I6, ImgSrc1: II6 }, { id: 23, ImgSrc: I7, ImgSrc1: II7 }, { id: 35, ImgSrc: I8, ImgSrc1: II8 }, { id: 22, ImgSrc: I9, ImgSrc1: II9 }, { id: 19, ImgSrc: I10, ImgSrc1: II10 }, { id: 35, ImgSrc: I11, ImgSrc1: II11 }, { id: 34, ImgSrc: I12, ImgSrc1: II12 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Women on Boards",
	        image: "https://winpeforum.com/assets/wob/banner.jpg",
	        description: "Winpe \u2013 Women on Boards (WoB) supports organisations in building stronger, future-ready boards through a curated network of experienced board directors and board-ready women leaders.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "        Winpe\u2019s Women on Boards",
	              _react2.default.createElement("br", null),
	              "Independent Director\u2019s Dilemma: When to Escalate, When to Trust Management"
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "July 31, 2026 (4:00 \u2013 5:00 PM)",
	                  _react2.default.createElement("br", null),
	                  "Format- Virtual (Zoom)"
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "Winpe \u2013 Women on Boards (WoB) supports organisations in building stronger, future-ready boards through a curated network of experienced board directors and board-ready women leaders. As part of this initiative, Self-Led Sessions bring women leaders together to exchange perspectives on real-world governance challenges and emerging boardroom priorities.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "This Knowledge Session explored one of the most nuanced responsibilities of an Independent Director\u2014determining when to rely on management's judgment and when circumstances warrant deeper scrutiny or escalation. Through practical scenarios and interactive discussions, participants examined the balance between constructive oversight and strategic partnership while reinforcing the principles of fiduciary responsibility, independence, and effective governance. The session focused on recognising early warning signals, asking incisive questions, addressing information asymmetry, navigating governance concerns, and exercising sound judgment while maintaining trust and accountability to support long-term organisational resilience.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The interactive format encouraged candid peer-to-peer dialogue among senior women leaders, who drew on their diverse leadership and board experiences to share practical perspectives on boardroom decision-making. The exchange of real-world insights enriched the discussion, reinforcing the value of collaborative learning and equipping participants with practical approaches to navigating complex governance challenges with confidence and effectiveness.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The session received strong positive feedback from participants, who appreciated the relevance of the topic and the opportunity to engage in meaningful discussions with fellow senior women leaders. Many found the practical scenarios highly relatable to boardroom situations and valued the exchange of diverse experiences and perspectives. Participants noted that the session strengthened their confidence in navigating complex governance challenges and enhanced their readiness to contribute effectively in the boardroom.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "b",
	                null,
	                "Note:"
	              ),
	              " The session was conducted under ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "Chatham House Rules"
	              ),
	              " and was ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "not recorded"
	              ),
	              ".",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "center",
	                null,
	                _react2.default.createElement("img", { src: "https://winpeforum.com/assets/wob31julyeventreport.png", style: { width: "80%" } })
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-winpe-wob-independent-directors-dilemma-index-js-7bc6ee86895d0e29181a.js